// IFRAME: //
function generateBlockedEmbedIframe(url) {
  return `data-src="${url}"
    data-cookiescript="accepted"
    name="Cookies sind deaktiviert"
    data-cookiecategory="functionality"
    `;
}
// IFRAME TAGGED: //
function generateBlockedEmbedIframeTagged(url, origin) {
  return `data-src="${url}"
    data-cookiescript="accepted"
    name="Cookies sind deaktiviert"
    data-cookiecategory="functionality"
    data-origin="${origin}"
    `;
}
// IFRAME YT: //
function generateBlockedEmbedIframeYT(url) {
  return `data-src="${url}"
    data-cookiescript="accepted"
    name="Cookies sind deaktiviert"
    data-cookiecategory="functionality"
    data-origin="youtube"
    `;
}
// EMBEDS VIA SCRIPTS: //
function generateBlockedEmbedScript(url) {
  return `type="text/plain"
    data-cookiescript="accepted"
    data-cookiecategory="functionality"
    src="${url}"
    `;
}
//
// FUNCTION TO CHECK IF OBJECT IS EMPTY:
function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

var ElementList = {};

function addElements(ElementList, newElements) {
  // console.log("addElements starts");

  if (isEmpty(ElementList)) {
    // console.log("ElementList is empty, Object is filled with new values");
    ElementList = newElements;
    // console.log("content of ElementList inside addElement function: ", ElementList);
    return ElementList;
  }
  else {
    // console.log("ElementList is already filled, Objects are assigned to each other");
    let newList = Object.assign(ElementList, newElements);

    return newList;
  }
  // console.log("addElements finished");
};

function blockEmbeds() {

  // FIND & REPLACE FUNCTIONS:
  const contentSection = document.querySelector("#smc_content_hook");
  const noscriptElement = document.querySelector("noscript") !== null ? document.querySelector("noscript") : "";
  var content = noscriptElement ? noscriptElement.textContent : "";
  // console.log("content: ", content);

  var embedsIframe = {};
  var embedsScript = {};

  embedsIframe = content.match(/<iframe.+?iframe>/g);
  embedsScript = content.match(/<script.+?script>/g);
  // console.log("content of embedsIframe: ", embedsIframe);
  // console.log("content of embedsScript: ", embedsScript);

  if (embedsIframe) {
    var updatedEmbedIframe = embedsIframe.map(embed => {
      var src = /src="([^"]*)/.exec(embed)[1];
      var url = src.split("/")[2];
      var origin = url.split(".")[1];
      // console.log('origin: ' + origin);

      if (((url.split(".")[0] == "www") || (url.split(".")[0] == "w")) && (origin)) {
        // console.log("replaced with origin");
        return embed.replace(/src="[^"]*"/, generateBlockedEmbedIframeTagged(src, origin));
      }
      //      else if (src.split("/")[2] === "www.youtube.com") {
      //        return embed.replace(/src="[^"]*"/, generateBlockedEmbedIframeYT(src));
      //      }
      else {
        // console.log("replaced default");
        return embed.replace(/src="[^"]*"/, generateBlockedEmbedIframe(src));
      }
      // console.log('source: ' + src);
      return embed;
    });

    embedsIframe.forEach((embed, index) => {
      content = content.replace(embed, updatedEmbedIframe[index]);
      // console.log('embed via iframe replaced (' + (index+1) + '):' + updatedEmbedIframe[index]);
    });
  }

  if (embedsScript) {
    var updatedEmbedScript = embedsScript.map(embed => {
      var src = /src="([^"]*)/.exec(embed)[1];

      return embed.replace(/src="[^"]*"/, generateBlockedEmbedScript(src));
      // console.log('source: ' + src);

      return embed;
    });

    embedsScript.forEach((embed, index) => {
      content = content.replace(embed, updatedEmbedScript[index]);
      // console.log('embed via script replaced (' + (index+1) + '):' + updatedEmbedScript[index]);
    });
  }
  
  noscriptElement ? noscriptElement.remove() : "";
  contentSection ? contentSection.insertAdjacentHTML( 'beforeend', content ) : "";
  // console.log('blockEmbeds finished');
}

blockEmbeds();

function replaceLinks() {
  var contentLinks = {};

  contentLinks = document.querySelectorAll("a");

  // console.log(contentLinks);

  for (var i = 0; i < contentLinks.length; i++) {
    if (contentLinks[i].hostname != window.location.hostname) {
      contentLinks[i].target = '_blank';
      contentLinks[i].rel = 'noopener';
      // console.log('link replaced: ' + contentLinks[i].hostname);
    }
  }
}

replaceLinks();